function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SettingsTemplate = require('./modtools-settings.template');
var SaitoContacts = require('../../../lib/saito/ui/modals/saito-contacts/saito-contacts');
var ModtoolsAppPermissions = require('./modtools-app-permissions');
var ModtoolsSettings = /*#__PURE__*/function () {
  function ModtoolsSettings(app, mod, container) {
    _classCallCheck(this, ModtoolsSettings);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.contacts = new SaitoContacts(app, mod, true);
    this.app_permissions = new ModtoolsAppPermissions(app, mod, '#modtools-apps');
  }
  return _createClass(ModtoolsSettings, [{
    key: "render",
    value: function render() {
      if (document.getElementById('modtools-settings')) {
        this.app.browser.replaceElementById(SettingsTemplate(this.app, this.mod), 'modtools-settings');
      } else {
        this.app.browser.addElementToSelector(SettingsTemplate(this.app, this.mod), this.container);
      }
      if (document.querySelector('#modtools-apps')) {
        this.app_permissions.render();
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var settings_self = this;
      if (document.getElementById('blacklisted-accounts')) {
        var _this$mod$blacklisted;
        if ((_this$mod$blacklisted = this.mod.blacklisted_publickeys) !== null && _this$mod$blacklisted !== void 0 && _this$mod$blacklisted.length) {
          document.getElementById('blacklisted-accounts').onclick = function (e) {
            _this.contacts.title = 'Blacklisted Accounts';
            _this.contacts.multi_button = 'Remove from Blacklist';
            _this.contacts.callback = function (keys) {
              var _iterator = _createForOfIteratorHelper(keys),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var key = _step.value;
                  _this.app.connection.emit('saito-unblacklist', key);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _this.render();
            };
            _this.contacts.render(_this.mod.blacklisted_publickeys);
          };
        }
      }
      if (document.getElementById('whitelisted-accounts')) {
        var _this$mod$whitelisted;
        if ((_this$mod$whitelisted = this.mod.whitelisted_publickeys) !== null && _this$mod$whitelisted !== void 0 && _this$mod$whitelisted.length) {
          document.getElementById('whitelisted-accounts').onclick = function (e) {
            _this.contacts.title = 'Whitelisted Accounts';
            _this.contacts.multi_button = 'Remove from Whitelist';
            _this.contacts.callback = function (keys) {
              var _iterator2 = _createForOfIteratorHelper(keys),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var key = _step2.value;
                  _this.app.connection.emit('saito-unwhitelist', key);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _this.render();
            };
            _this.contacts.render(_this.mod.whitelisted_publickeys);
          };
        }
      }
      if (document.getElementById('add-whitelist')) {
        document.getElementById('add-whitelist').onclick = function (e) {
          e.stopPropagation();
          e.preventDefault();
          _this.contacts.title = 'Saved Keys';
          _this.contacts.multi_button = 'Add to Whitelist';
          _this.contacts.callback = function (keys) {
            var _iterator3 = _createForOfIteratorHelper(keys),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var key = _step3.value;
                _this.app.connection.emit('saito-whitelist', {
                  publicKey: key,
                  duration: -1
                });
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            _this.render();
          };
          _this.contacts.render();
        };
      }
      if (document.getElementById('none_mod')) {
        document.getElementById('none_mod').onclick = function (e) {
          _this.mod.permissions.mode = 'none';
          _this.mod.save();
        };
      }
      if (document.getElementById('server_mod')) {
        document.getElementById('server_mod').onclick = function (e) {
          _this.mod.permissions.mode = 'server';
          _this.mod.save();
        };
      }
      if (document.getElementById('friends_mod')) {
        document.getElementById('friends_mod').onclick = function (e) {
          _this.mod.permissions.mode = 'friends';
          _this.mod.save();
        };
      }
      if (document.getElementById('custom_mod')) {
        document.getElementById('custom_mod').onclick = function (e) {
          _this.mod.permissions.mode = 'custom';
          _this.mod.save();
        };
      }
    }
  }]);
}();
module.exports = ModtoolsSettings;